import Swiper from '../vendors/swiper.min.js';

const selectors = {
  badgesCarousel: '[data-carousel]',
  badging: '[data-badging]',
  carouselArrowLeft: '[data-arrow-left]',
  carouselArrowRight: '[data-arrow-right]',
  carouselContainer: '[data-carousel-container]',
  carouselScrollbar: '[data-scrollbar]',
  carouselSlide: '.badge-card',
};

const dom = {};

const cacheDom = () => {
  dom.badging = document.querySelectorAll(selectors.badging);
};

const handleBadgingEvents = () => {
  if (dom.badging) {
    dom.badging.forEach((badging) => {
      const thisBadging = badging;
      const carouselContainer = thisBadging.querySelector(
        selectors.carouselContainer,
      );
      const badgesCarousel = thisBadging.querySelector(
        selectors.badgesCarousel,
      );
      const carouselSlides = carouselContainer.querySelectorAll(
        selectors.carouselSlide,
      ).length;

      const carouselScrollbar = thisBadging.querySelector(
        selectors.carouselScrollbar,
      );
      const carouselArrowRight = thisBadging.querySelector(
        selectors.carouselArrowRight,
      );
      const carouselArrowLeft = thisBadging.querySelector(
        selectors.carouselArrowLeft,
      );

      let slidesToShow = '';
      let slideOffset = '';
      let slidesToShowTablet = '';
      let slideOffsetTablet = '';
      let slidesToShowMobile = 1.2;
      let slideOffsetMobile = 24;

      if (carouselSlides > 4) {
        slidesToShow = 4.4;
        slideOffset = 48;
      } else {
        slidesToShow = 4;
        slideOffset = 0;
      }

      if (carouselSlides > 2) {
        slidesToShowTablet = 2.3;
        slideOffsetTablet = 48;
      } else {
        slidesToShowTablet = 2;
        slideOffsetTablet = 0;
      }

      if (carouselSlides < 2) {
        slidesToShowMobile = 1;
        slideOffsetMobile = 0;
      }

      const swiper = new Swiper(carouselContainer, {
        breakpoints: {
          1024: {
            centerInsufficientSlides: true,
            slidesOffsetAfter: slideOffset,
            slidesOffsetBefore: slideOffset,
            slidesPerView: slidesToShow,
            spaceBetween: 32,
          },
          1441: {
            centerInsufficientSlides: true,
            slidesOffsetAfter: slideOffset,
            slidesOffsetBefore: slideOffset,
            slidesPerView: slidesToShow,
            spaceBetween: 32,
          },
          752: {
            centerInsufficientSlides: true,
            slidesOffsetAfter: slideOffsetTablet,
            slidesOffsetBefore: slideOffsetTablet,
            slidesPerView: slidesToShowTablet,
            spaceBetween: 32,
          },
        },
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
        },
        navigation: {
          nextEl: carouselArrowRight,
          prevEl: carouselArrowLeft,
        },
        scrollbar: {
          draggable: true,
          el: carouselScrollbar,
        },
        slidesOffsetAfter: slideOffsetMobile,
        slidesOffsetBefore: slideOffsetMobile,
        slidesPerView: slidesToShowMobile,
        spaceBetween: 12,
      });
    });
  }
};

const badgingCarouselSection = {
  init() {
    cacheDom();
    handleBadgingEvents();
  },
};

export default badgingCarouselSection;
